const carbody = {
  brand: 'Marca',
  car: 'Vettura',
  description: 'Descrizione',
  supplier_code: 'Codice fornitore',
  cati_code: 'Codice CATI',
  code: 'Codice prodotto',
  price: 'Prezzo',
  OE: 'Codice OE',
  mt3: 'MT3',
  weight: 'Peso lordo',
  ean: 'Codice EAN',
  certification: 'Certificazione',
  upload_missed:
    'Alcuni prezzi inseriti non hanno un codice prodotto corrispondente',
  product_id: 'ID Prodotto',
  name: 'Nome',
  supplier_label: 'Fornitore',
  created_at: 'Data inserimento',
  previous_price: 'Il prezzo precedente è {value}',
  date_from_hint: 'Aggiungi data da',
  date_to_hint: 'Aggiungi data a',
  date_error: 'Il campo data da deve essere valorizzato!',
  // Ricerca libera della griglia /carbody/prices: cerca nel CODICE PRODOTTO
  // del fornitore (`car_body_products.code`, la colonna "Codice prodotto"),
  // NON nel codice anagrafico del fornitore (`supplier_code`).
  index_search_label: 'Cerca per codice prodotto del fornitore',
  supplier_products: 'Prodotti Fornitori',
  cars: 'Autovetture',
  class_merch: 'Scegli la classe merceologica',
  total: 'Totale',
  insert_date: 'Data inserimento',
  height: 'Altezza',
  length: 'Lunghezza',
  width: 'Larghezza',
  clear_orders: 'Cancella ordini',
  confirm_clear_orders:
    'Gli ordini non sono stati cancellati, vuoi proseguire?',
  available: 'Nascondi non disponibili',
  categories_add_tag: 'Aggiungi la categoria prodotto',
  categories_hint: 'Categoria prodotto',
  carbody_new_product_title: 'Crea nuovo prodotto carrozzeria',
  carbody_edit_product_title: 'Modifica cod. CATI',
  cati_code_hint: 'Aggiungi Codice CATI',
  steps: {
    general: 'Generale',
    save: 'Salva',
    cars: 'Autovetture',
    description: 'Descrizione',
    product_details: 'Dettagli prodotto',
    warehouses: 'Magazzini inattivi',
  },
  select_car_title: 'Seleziona auto compatibili',
  description_label: 'Descrizione prodotto',
  description_hint: 'Aggiungi descrizione prodotto',
  active: 'Prodotto attivo',
  active_label: 'Seleziona codice CATI attivo/disattivo',
  product_available: 'Seleziona prodotto attivo/disattivo',
  oem_hint: 'OEM prodotto',
  oem_label: 'Aggiungi OEM prodotto',
  ean_hint: 'EAN prodotto',
  ean_label: 'Aggiungi EAN prodotto',
  price_hint: 'Prezzo prodotto',
  price_date: 'Data prezzo',
  price_label: 'Aggiungi prezzo prodotto',
  class: 'Classe merceologica',
  supplier_id: 'Fornitore',
  brands: 'Marca auto',
  models: 'Modello auto',
  OEM: 'OEM',
  EAN: 'EAN',
  category: 'Categoria prodotto',
  quality: 'Qualità',
  quality_label: 'Qualità prodotto',
  quality_hint:
    'Valore importato dal listino (colonna Qualità) — es. E, Q; lasciare vuoto se non presente.',
  create_new: 'Crea nuovo modello',
  supplier_product_code: 'Codice prodotto del fornitore',
  supplier_product_code_hint: 'Aggiungi il codice prodotto del fornitore',
  supplier_cost_label: 'Costo',
  supplier_barcode_label: 'Barcode',
  submit_product: 'Salva prodotto',
  export_products: 'Esporta',
  export_orders: 'Esporta per SuperMax',
  export_report: 'Esporta riepilogo',
  new_codes: 'nuovi prodotti',
  new_code: 'nuovo prodotto',
  cati_code_search: 'Cerca per codice CATI o Codice prodotto fornitore',
  cati_code_edit_page: 'Codice CATI o Codice prodotto fornitore',
  id: 'ID',
  save_new_product: 'Salva codice',
  new_product_saved: 'Salvato codice',
  products_with_code: 'Prodotti con codice',
  back_to_first_step: 'Torna alla pagina iniziale',
  minumum_margin: 'Margine minimo',
  margin: 'Margine',
  go_back_to_order_bot: "Torna all'OrderBot",
  mpc: 'MPC',
  diff: 'Diff.',
  target_price: 'Target price',
  supplier_product_available: 'Prodotto fornitore disponibile',
  upload_message_1: 'Il lavoro di caricamento {batch_id} é in corso.',
  upload_message_2:
    'Appena sarà terminato una mail riepilogativa sarà inviata a {user_email} con allegato un files dei prodotti che non hanno un codice CATI.',
  inactive_warehouses: 'Magazzini inattivi',
  proceed_anyway: 'Procedi comunque',
  valid_from_hint:
    'Prezzo valido dal (se vuoto, prezzo valido dalla data corrente!)',
  oem_alert: 'OEM non univoco!',
  oem_block_title: 'Gli OEM associati al prodotto sono già presenti:',
  oem_block_supplier: 'Fornitore:',
  oem_block_product: 'Prodotto:',
  oem_block_equivalent_codes: 'Codici OEM equivalenti:',
  is_partial_catalogue: 'Caricamento parziale',
  price_save_success: 'Prezzo aggiornato con successo',
  code_save_success: 'Codice prodotto aggiornato con successo',
  code_edit_confirm_immediate:
    'Confermando, il codice verrà rimosso subito da ciascun prodotto CATI indicato, insieme al relativo prezzo di questo fornitore, e assegnato a questa riga.',
  partial_future_date_error:
    'In modalità parziale non è possibile inserire una data futura',
  unavailable: 'Non disponibile',
  proposals: 'Proposte',
  main_supplier_tooltip:
    'Imposta come fornitore principale per le future proposte',
  main_supplier: 'Fornitore principale',
  recalculate_for_supplier: 'Ricalcola la proposta con {supplier}',
  send_to_supermax: 'Invia a Supermax',
  send_to_supermax_message: 'Inviare a SuperMax gli ordini fornitori generati?',
  extra_discount: 'Sconto extra',
  note: 'Note di invio',
  total_orders: 'Totale ordini',
  product_item: 'Prodotto',
  product_list_empty: 'Nessun prodotto. Premi + per aggiungere.',
  save_all: 'Salva tutti',
  add_product: 'Aggiungi prodotto',
  cati_code_taken: 'Codice CATI già esistente',
  cati_code_dup_in_batch: 'Codice CATI duplicato tra i prodotti',
  batch_create_success: 'Prodotti creati: {count}',
  batch_create_errors: 'Alcuni prodotti non sono stati creati',
  future_mode_note:
    'Modalità futura: il catalogo attuale non verrà modificato; il prezzo sarà attivo dalla data indicata',
  tmp_not_found_error:
    'Nessun prezzo importato trovato per questo fornitore / codice',
  show_hidden: 'Mostra nascosti',
  hide_product: 'Nascondi',
  unhide_product: 'Mostra',
  row_actions: 'Azioni',
  row_actions_title: 'Azioni sul prodotto',
  create_new_from_tmp: 'Crea nuovo prodotto',
  update_existing_product: 'Aggiorna prodotto esistente',
  export_xlsx: 'Esporta XLSX',
  oem_match_modal_title: 'OEM già presente',
  oem_match_modal_body:
    'È stato trovato un prodotto dello stesso fornitore con lo stesso OEM. Vuoi copiare i dati descrittivi?',
  oem_match_modal_note:
    'Verranno compilati: descrizione, EAN, categoria, classe merceologica e lista OEM. Codice CATI e codice fornitore non verranno modificati.',
  oem_match_confirm: 'Sì, compila',
  oem_match_cancel: 'No, mantieni',
  clear_filters: 'Pulisci filtri',
  copiato: 'Copiato',
  class_merch_singular: 'Classe merceologica',
  active_field: 'Attivo',
  active_field_disabled_hint: "Modificabile solo dopo l'invio a Supermax.",
  active_field_disabled_tooltip:
    'Un nuovo prodotto viene sempre creato attivo in Supermax; per disattivarlo, invialo prima, poi proponi la modifica da "Aggiorna prodotti".',
  aggiungi_fornitore: 'Aggiungi fornitore',
  usa_come_descrizione: 'Usa come descrizione prodotto',
  remove_supplier_row: 'Rimuovi fornitore',
  oem_tmp_modal_title: 'Prodotti trovati con lo stesso OEM',
  oem_tmp_modal_body:
    'Seleziona i fornitori/codici da aggiungere come righe fornitore per questo prodotto:',
  oem_tmp_modal_confirm: 'Aggiungi selezionati',
  oem_tmp_modal_cancel: 'Annulla',
  oem_tmp_no_new_matches: 'Nessun nuovo fornitore trovato per questo OEM.',
  pending_search_label: 'Cerca per codice CATI o descrizione',
  pending_edit_action: 'Modifica prodotto',
  pending_edit_title: 'Modifica prodotto da inviare',
  pending_update_save: 'Salva modifiche',
  pending_update_success: 'Prodotto aggiornato con successo',
  pending_delete_action: 'Elimina prodotto',
  pending_delete_title: 'Elimina prodotto da inviare',
  pending_delete_body:
    "Stai per eliminare definitivamente il prodotto e tutti i suoi fornitori. Le righe corrispondenti torneranno nella lista dei nuovi prodotti da rivedere. L'operazione non è reversibile.",
  pending_delete_confirm_checkbox: "Confermo l'eliminazione",
  pending_delete_confirm_button: 'Elimina',
  pending_delete_success: 'Prodotto eliminato con successo',
  pending_delete_already_sent:
    'Il prodotto risulta già inviato a Supermax: impossibile eliminarlo',
  pending_delete_body_update:
    'Stai per scartare questa proposta di aggiornamento. Il prodotto originale non verrà modificato. Questa operazione non è reversibile.',
  pending_type_column: 'Tipo',
  pending_type_new: 'Nuovo',
  pending_type_update: 'Aggiornamento',
  pending_export_success: 'Esportazione completata con successo',

  // ── Create-product rework (2026-07-07) — bulk actions bar ────────────────
  bulk_selected_count: '{count} selezionati',
  bulk_overwrite: 'Sovrascrivi marca/modello',
  bulk_append: 'Aggiungi marca/modello',
  bulk_oem_refresh: 'Aggiorna OEM',
  bulk_delete: 'Elimina selezionati',
  bulk_clear_selection: 'Deseleziona tutto',
  bulk_delete_confirm_message:
    'Stai per eliminare {count} prodotti dalla bozza corrente. Continuare?',

  // ── Bulk car brand/model modal ────────────────────────────────────────────
  bulk_car_overwrite_title: 'Sovrascrivi marca/modello',
  bulk_car_overwrite_body:
    'La selezione è precompilata con marche e modelli comuni a tutti i prodotti selezionati. Confermando, la marca/modello di OGNI prodotto selezionato verrà sostituita con quella scelta qui.',
  bulk_car_append_title: 'Aggiungi marca/modello',
  bulk_car_append_body:
    'Scegli marche/modelli da aggiungere. Confermando, verranno aggiunti a quelli già presenti su ogni prodotto selezionato (nessuna sostituzione).',

  // ── Bulk OEM refresh modal ────────────────────────────────────────────────
  bulk_oem_refresh_title: 'Aggiorna OEM — prodotti selezionati',
  bulk_oem_refresh_none:
    'Nessun nuovo fornitore trovato per gli OEM dei prodotti selezionati.',
  bulk_oem_refresh_group_caption: '{count} nuovi fornitori trovati',

  // ── Missing-info prefill/discovery modal (item 5, D3) ─────────────────────
  missing_info_modal_title: 'Informazioni trovate',
  missing_info_fill_section_title: 'Questi campi mancanti verranno completati:',

  // ── Review step (item 4) ──────────────────────────────────────────────────
  review_step_empty: 'Nessun prodotto da rivedere.',
  next_step: 'Avanti',
  image_url_label: 'Link immagine prodotto',
  image_url_hint: 'Incolla il link (URL) di un’immagine del prodotto',
  image_url_load_error: "Impossibile caricare l'immagine da questo link",
  image_url_empty: 'Nessuna immagine inserita',
  technical_data_label: 'Dati tecnici',
  found_images_label: 'Immagini trovate',
  technical_data_scaffold_note:
    'Non ancora disponibile — in arrivo con la connessione a Kromeda/altro DB',
  found_images_scaffold_note:
    'Non ancora disponibile — in arrivo con il servizio di ricerca immagini',

  // ── Shared draft banner ───────────────────────────────────────────────────
  shared_draft_banner:
    'Stai continuando una bozza condivisa già in corso (ultimo salvataggio: {time}).',
  relative_time_just_now: 'pochi istanti fa',
  relative_time_minutes: '{count} min fa',
  relative_time_hours: '{count} ore fa',
  relative_time_days: '{count} giorni fa',

  // ── Manual draft save ("Salva bozza") ─────────────────────────────────────
  save_draft: 'Salva bozza',
  draft_saved: 'Bozza salvata',
  draft_unsaved_hint: 'Modifiche non salvate',
  draft_saved_hint: 'Salvato {time}',

  // ── Item 10 — existing CATI code in create flow ───────────────────────────
  existing_cati_prompt_message:
    'Il codice CATI {code} esiste già. Vuoi proporre un aggiornamento invece di inserirlo come nuovo prodotto?',
  existing_cati_prompt_confirm: 'Sì, proponi aggiornamento',
  existing_cati_prompt_cancel: 'No, mantieni come nuovo',

  // ── Update-proposal flow (item 8) ─────────────────────────────────────────
  update_field_changed_chip: 'Modificato',
  update_field_lock: 'Blocca campo',
  update_field_unlock: 'Sblocca per modificare',
  update_proposal_submit: 'Proponi aggiornamento',
  update_dialog_title: 'Proponi aggiornamento prodotto',
  update_dialog_load_error: 'Impossibile caricare i dati del prodotto',
  update_proposal_success: 'Proposta di aggiornamento salvata con successo',
  update_readonly_no_channel_hint:
    'Campo non modificabile: non viene mai trasmesso a Supermax.',

  // ── Update-proposal flow — Marca/Modello auto (2026-09-17) ────────────────
  car_links_label: 'Marca / Modello auto',
  car_links_hint:
    'Il collegamento auto viene applicato solo all\'invio ("Esporta per Supermax"). Un modello aggiunto ora comparirà in fondo al proprio blocco nel catalogo fornitori.',
  car_links_clear_confirm_title: 'Rimuovere tutti i modelli auto?',
  car_links_clear_confirm_message:
    "All'invio il prodotto perderà tutti i collegamenti auto e non comparirà più nel catalogo fornitori.",

  // ── Existing supplier row — code lookup on edit (2026-09-15) ──────────────
  supplier_code_no_match_hint:
    'Nessun prodotto in catalogo corrisponde a questo codice: prezzo e barcode non sono stati modificati.',
  supplier_code_overwrite_confirm_title: 'Aggiornare i valori del fornitore?',
  supplier_code_overwrite_confirm_message:
    'È stata trovata una corrispondenza per il nuovo codice fornitore, con questi valori diversi da quelli attuali: {changes}. Vuoi sovrascriverli?',

  // ── Linked supplier codes — steal from another CATI product (2026-09-18) ──
  supplier_code_linked_option_caption: 'Collegato a CATI {codes}',
  supplier_code_steal_product_line: 'CATI {cati_code} ({description})',
  supplier_code_steal_product_line_no_description: 'CATI {cati_code}',
  supplier_code_steal_confirm_title: 'Scollegare questo codice fornitore?',
  supplier_code_steal_confirm_title_strong:
    "ATTENZIONE: sparizione di prodotto/i dall'applicativo",
  supplier_code_steal_confirm_ok: 'Scollega e usa',
  supplier_code_steal_confirm_intro:
    'Il codice fornitore "{code}" è già collegato a: {products}.',
  supplier_code_steal_confirm_immediate:
    "Confermando, il fornitore verrà rimosso subito da chi lo ha ora, insieme al relativo prezzo; questa riga lo riceverà solo al salvataggio o all'invio.",
  supplier_code_steal_confirm_pending_note:
    'La proposta di aggiornamento in sospeso di ciascun prodotto indicato (CATI {codes}) verrà modificata di conseguenza.',
  supplier_code_steal_confirm_other_claim_note:
    'Il codice potrebbe comunque essere indicato anche nella proposta di aggiornamento in sospeso di un altro prodotto non elencato qui: in tal caso potrebbe ricomparire anche lì al prossimo invio.',
  supplier_code_steal_confirm_last_supplier_strong:
    "ATTENZIONE: per CATI {codes} questo è l'unico fornitore rimasto. Non essendo ancora stato inviato a Supermax, ogni prodotto indicato qui sparirà da ogni schermata e non potrà più essere recuperato dall'applicativo.",
  supplier_code_steal_success: 'Codice scollegato e assegnato a questa riga.',
  supplier_code_steal_success_with_proposal:
    'Codice scollegato e assegnato a questa riga. {notes}',
  supplier_code_steal_proposal_updated_line:
    'La proposta in sospeso di CATI {cati_code} è stata aggiornata: il fornitore con codice {code} è stato rimosso.',
  supplier_code_steal_proposal_updated_oem_note:
    ' Anche i codici OE dedicati a quel fornitore sono stati rimossi dalla proposta.',
  supplier_code_steal_already_unlinked:
    'CATI {cati_code} aveva già perso questo codice fornitore prima di questa conferma: la riga lo ha comunque ricevuto.',
  supplier_code_steal_links_changed_retry:
    "L'elenco dei prodotti collegati è cambiato nel frattempo: ricontrolla e riconferma.",
  supplier_list_min_error:
    'Un prodotto attivo deve avere almeno un fornitore. Solo un prodotto disattivo può restare senza fornitori.',

  // ── Removing every supplier — inactive products only (2026-09-30, task 031) ──
  supplier_list_reactivating_error:
    'Il prodotto viene riattivato: un prodotto attivo deve avere almeno un fornitore.',
  suppliers_empty_inactive_hint:
    'Nessun fornitore: consentito perché il prodotto è disattivo. Il prodotto resterà salvato senza fornitori e senza prezzi.',
  suppliers_empty_combined_hint:
    'Il prodotto verrà disattivato con questo invio, ma i fornitori NON verranno rimossi finché Supermax non avrà applicato la disattivazione (di norma il giorno successivo, quando il prodotto risulterà "Disattivo" in "Aggiorna prodotti"). Dovrai riproporre la rimozione dei fornitori in un secondo momento.',
  suppliers_empty_state_hint:
    'Nessun fornitore collegato a questo prodotto. Sblocca la sezione per aggiungerne uno.',
  suppliers_remove_all_confirm_title: 'Rimuovere tutti i fornitori?',
  suppliers_remove_all_confirm_message:
    "All'invio verranno eliminati tutti i prezzi (anche quelli futuri) e i codici OE dei fornitori di questo prodotto. Supermax non viene informato della rimozione dei fornitori.",
  suppliers_remove_all_confirm_message_combined:
    'Questo invio disattiverà il prodotto, ma i fornitori NON verranno rimossi finché Supermax non avrà applicato la disattivazione (di norma il giorno successivo). Quando il prodotto risulterà "Disattivo" in "Aggiorna prodotti", dovrai riproporre la rimozione dei fornitori.',

  // ── "Aggiorna prodotti" list (item 8) ─────────────────────────────────────
  updatable_search_label:
    'Cerca per codice CATI, descrizione, codice prodotto del fornitore o OEM',
  updatable_pending_column: 'Proposta in corso',
  updatable_pending_chip: 'In corso',
  updatable_propose_action: 'Proponi aggiornamento',
  // 2026-09-30, task 031: also used as the "active" column header (a single
  // binary state, same convention as `updatable_pending_chip` above).
  updatable_inactive_chip: 'Disattivo',
  updatable_suppliers_column: 'Fornitori',

  // ── "Aggiorna prodotto esistente" from a tmp-products row ─────────────────
  update_from_tmp_dialog_title: 'Aggiorna prodotto esistente',
  update_from_tmp_hint:
    'Inserisci il codice CATI del prodotto a cui aggiungere questo fornitore.',
  update_from_tmp_not_found: 'Codice CATI non trovato',
  update_from_tmp_search: 'Cerca',
  update_from_tmp_go: "Vai all'aggiornamento",

  // ── Per-product notes (item 2) ────────────────────────────────────────────
  notes_label: 'Note',

  // ── Review step — per-product entered-data summary (item 3) ──────────────
  review_summary_title: 'Riepilogo dati inseriti',
  review_summary_category: 'Categoria / Classe merceologica',
  review_summary_ean: 'EAN',
  review_summary_oem: 'OEM',
  review_summary_cars: 'Marca / Modello',
  review_summary_suppliers: 'Fornitori',
  review_summary_no_cars: 'Nessuna marca/modello selezionato',
  review_summary_no_suppliers: 'Nessun fornitore inserito',
  review_summary_no_value: '—',

  // ── "Prodotti da inviare" sent/not-sent views + selection + export (item 4) ──
  pending_view_to_send: 'Da inviare',
  pending_view_sent: 'Inviati',
  pending_type_sent: 'Inviato',
  pending_export_all: 'Esporta tutto',
  pending_export_selected: 'Esporta selezionati ({count})',
  pending_export_confirm_message_all:
    'Verranno generati i file per Supermax per TUTTI i prodotti/proposte da inviare e le proposte di aggiornamento incluse saranno segnate come inviate. Procedere?',
  pending_export_confirm_message_selected:
    'Verranno generati i file per Supermax per i {count} elementi selezionati e le proposte di aggiornamento incluse saranno segnate come inviate. Procedere?',

  // ── Catalogue-export supplier list ("Fornitori esportazione") ────────────
  export_suppliers_preview_title: 'Anteprima colonne file CSV',
  export_suppliers_empty_warning:
    "Nessun fornitore configurato: l'esportazione non sarà possibile finché non ne aggiungi almeno uno.",
  export_supplier_add_title: 'Aggiungi fornitore esportazione',
  export_supplier_edit_title: 'Modifica fornitore esportazione',
  export_supplier_name_label: 'Nome (intestazione CSV)',
  export_supplier_name_hint:
    'Diventa tre intestazioni del file CSV: {name}Cod, Oem{name}, Prezzo{name} — es. "Van Wezel" diventa "VanWezel"',
  export_supplier_name_pattern_error:
    'Solo lettere e numeri, senza spazi o simboli',
  export_supplier_name_max_error: 'Massimo 60 caratteri',
  export_supplier_create_success:
    'Fornitore aggiunto alla lista di esportazione',
  export_supplier_update_success: 'Fornitore aggiornato',
  export_supplier_delete_confirm:
    'Rimuovere "{name}" dalla lista di esportazione?',
  export_supplier_delete_success:
    'Fornitore rimosso dalla lista di esportazione',
  export_supplier_move_up: 'Sposta su',
  export_supplier_move_down: 'Sposta giù',
  export_supplier_columns_col: 'Colonne CSV',

  // ── "ESPORTA" (carbody/prices) format picker ──────────────────────────────
  export_format_csv: 'CSV',
  export_format_xlsx: 'Excel (.xlsx)',

  // ── "ESPORTA" (carbody/prices) failing on an empty export supplier list ──
  export_no_suppliers_warning:
    'Esportazione non disponibile: configura almeno un fornitore per il file CSV.',
  export_no_suppliers_action: 'Configura fornitori',

  // ── "Marche e modelli" (cars-data CRUD) ───────────────────────────────────
  cars_data_search_label: 'Cerca per marca o modello',
  cars_data_brand_filter_label: 'Filtra per marca',
  cars_data_model_filter_label: 'Filtra per modello',
  cars_data_model: 'Modello',
  cars_data_manufactured_from: 'Prodotta dal',
  cars_data_manufactured_to: 'Prodotta al',
  cars_data_products_count: 'Prodotti collegati',
  cars_data_add_button: 'Aggiungi vettura',
  cars_data_add_title: 'Aggiungi vettura',
  cars_data_edit_title: 'Modifica vettura',
  cars_data_brand_hint:
    'Modificare la marca qui sposta SOLO questa vettura sotto la nuova marca: non rinomina la marca ovunque. Per rinominarla ovunque usa "Rinomina marca".',
  cars_data_brand_max_error: 'Massimo 20 caratteri',
  cars_data_model_max_error: 'Massimo 30 caratteri',
  cars_data_manufactured_from_label: 'Prodotta dal',
  cars_data_manufactured_to_label: 'Prodotta al (opzionale)',
  cars_data_manufactured_to_error:
    'La data di fine produzione deve essere uguale o successiva alla data di inizio',
  cars_data_create_success: 'Vettura creata con successo',
  cars_data_update_success: 'Vettura aggiornata con successo',
  cars_data_delete_confirm_message:
    'Eliminare definitivamente {brand} {model}? Questa operazione non è reversibile.',
  cars_data_delete_success: 'Vettura eliminata con successo',
  cars_data_delete_blocked_title: 'Vettura collegata a prodotti',
  cars_data_delete_blocked_message:
    '{brand} {model} è collegata a {count} prodotto/i. Eliminandola, questi prodotti perderanno il collegamento a questa vettura e USCIRANNO SILENZIOSAMENTE dal catalogo di esportazione (il file ha una riga per ogni coppia prodotto/vettura: senza vettura collegata, il prodotto non genera più righe). Questa operazione non è reversibile.',
  cars_data_delete_blocked_codes_label: 'Prodotti coinvolti (primi 10):',
  cars_data_delete_blocked_more: '… e altri {count}',
  cars_data_delete_force_confirm: 'Elimina comunque',
  cars_data_rename_brand_button: 'Rinomina marca',
  cars_data_rename_brand_title: 'Rinomina marca',
  cars_data_rename_brand_from_label: 'Marca attuale',
  cars_data_rename_brand_to_label: 'Nuova marca',
  cars_data_rename_brand_warning:
    'La corrispondenza non distingue maiuscole/minuscole: "fiat", "Fiat" e "FIAT" verranno rinominate insieme in un\'unica operazione.',
  cars_data_rename_brand_confirm_message:
    'Rinominare la marca "{from}" in "{to}" su TUTTE le vetture che la usano? La corrispondenza non distingue maiuscole/minuscole: eventuali varianti come "{from}" in maiuscolo/minuscolo diverso verranno rinominate insieme. Operazione non reversibile.',
  cars_data_rename_brand_success:
    'Marca rinominata: {count} vetture aggiornate',

  // ── Catalogue master sync (task 2026-08-28-014) ──────────────────────────
  catalogue_sync_new_title: 'Nuova sincronizzazione catalogo',
  catalogue_sync_upload_label: 'Seleziona il file del catalogo master',
  catalogue_sync_upload_hint:
    'File .xlsx o .csv del catalogo master (circa 50 MB)',
  catalogue_sync_uploading: 'Caricamento in corso…',
  catalogue_sync_upload_success: 'File caricato: {name}',
  catalogue_sync_upload_size: 'Dimensione: {size}',
  catalogue_sync_header_ok: 'Struttura del file verificata',
  catalogue_sync_header_ko_title: 'Il file non ha la struttura attesa',
  catalogue_sync_header_ko_message: 'Colonne mancanti nel file caricato:',
  catalogue_sync_reupload: 'Carica un altro file',
  catalogue_sync_options_title: 'Opzioni',
  catalogue_sync_mode_label: 'Modalità',
  catalogue_sync_mode_dry_run: 'Simulazione',
  catalogue_sync_mode_write: 'Scrittura',
  catalogue_sync_price_date_label: 'Data di validità prezzi',
  catalogue_sync_prune_links_label:
    'Rimuovi collegamenti prodotto-veicolo non più presenti nel file',
  catalogue_sync_advanced_toggle: 'Opzioni avanzate',
  catalogue_sync_chunk_size_label: 'Dimensione blocco di elaborazione',
  catalogue_sync_chunk_size_hint:
    'Tra 200 e 5000, default 2000. Modificare solo su indicazione del supporto tecnico.',
  catalogue_sync_stages_label: 'Fasi da eseguire',
  catalogue_sync_stages_hint:
    'Lascia tutte le fasi selezionate salvo diversa indicazione del supporto tecnico.',
  catalogue_sync_stage_parse: 'Lettura file',
  catalogue_sync_stage_cars: 'Veicoli',
  catalogue_sync_stage_links: 'Collegamenti prodotto-veicolo',
  catalogue_sync_stage_info: 'Informazioni prodotto',
  catalogue_sync_stage_prices: 'Prezzi',
  catalogue_sync_simulate_button: 'Simula',
  catalogue_sync_write_button: 'Esegui',
  catalogue_sync_write_confirm_title: 'Conferma scrittura',
  catalogue_sync_write_confirm_message:
    'Questa operazione riscrive il catalogo carrozzeria (veicoli, collegamenti, informazioni prodotto e prezzi) in base al file caricato. Continuare?',
  catalogue_sync_write_confirm_checkbox:
    'Confermo di voler avviare la scrittura',
  catalogue_sync_write_confirm_button: 'Avvia scrittura',
  catalogue_sync_start_error_locked: 'Una sincronizzazione è già in corso.',
  catalogue_sync_start_error_locked_action: 'Vai allo storico',
  catalogue_sync_run_started: 'Sincronizzazione avviata',
  catalogue_sync_status_title: 'Stato sincronizzazione',
  catalogue_sync_status_queued: 'In attesa',
  catalogue_sync_status_queued_hint:
    'In attesa che un processo si liberi: può richiedere qualche istante.',
  catalogue_sync_status_running: 'In corso',
  catalogue_sync_status_completed: 'Completata',
  catalogue_sync_status_failed: 'Non riuscita',
  catalogue_sync_status_cancelled: 'Annullata',
  catalogue_sync_elapsed: 'Tempo trascorso: {time}',
  catalogue_sync_stage_progress: 'Fase {index} di {count}: {stage}',
  catalogue_sync_counters_title: 'Contatori',
  catalogue_sync_suppliers_title: 'Fornitori',
  catalogue_sync_error_title: 'Errore',
  catalogue_sync_cancelled_note:
    'I blocchi già elaborati e salvati non vengono annullati.',
  catalogue_sync_cancel_button: 'Annulla',
  catalogue_sync_cancel_confirm_message:
    "L'annullamento è cooperativo: i blocchi già salvati non verranno ripristinati. Continuare?",
  catalogue_sync_cancel_requested: 'Annullamento richiesto',
  catalogue_sync_resume_button: 'Riprendi',
  catalogue_sync_resume_confirm_message:
    'Riprendere la sincronizzazione dal punto in cui si è interrotta?',
  catalogue_sync_resume_requested: 'Ripresa richiesta',
  catalogue_sync_report_summary_button: 'Scarica riepilogo',
  catalogue_sync_report_skipped_button: 'Scarica righe scartate',
  catalogue_sync_write_from_dry_run_button:
    'Esegui la scrittura con questo file',
  catalogue_sync_write_from_dry_run_unavailable:
    'Non è possibile avviare la scrittura: il file di origine di questa esecuzione non è più disponibile.',
  catalogue_sync_stale_warning:
    'Nessun progresso rilevato da {minutes} minuti: la sincronizzazione potrebbe essersi bloccata. Se il problema persiste, contatta il supporto tecnico.',
  catalogue_sync_closing_tab_note:
    'Puoi chiudere questa pagina: la sincronizzazione continua sul server. Ritrova lo stato dallo storico.',
  catalogue_sync_history_title: 'Storico sincronizzazioni',
  catalogue_sync_history_new_button: 'Nuova sincronizzazione',
  catalogue_sync_history_empty: 'Nessuna sincronizzazione eseguita.',
  catalogue_sync_history_col_date: 'Data',
  catalogue_sync_history_col_user: 'Utente',
  catalogue_sync_history_col_mode: 'Modalità',
  catalogue_sync_history_col_status: 'Stato',
  catalogue_sync_history_col_duration: 'Durata',
  catalogue_sync_history_col_actions: 'Azioni',
  catalogue_sync_history_view_action: 'Vedi dettaglio',
  catalogue_sync_upload_missing_no_columns: 'Il file non ha il formato atteso.',
  catalogue_sync_counter_rows_read: 'Righe lette',
  catalogue_sync_counter_rows_skipped_header_or_blank:
    'Righe saltate (intestazione/vuote)',
  catalogue_sync_counter_code_blank: 'Codice mancante',
  catalogue_sync_counter_products_matched: 'Prodotti trovati',
  catalogue_sync_counter_products_not_found: 'Prodotti non trovati',
  catalogue_sync_counter_cars_matched: 'Veicoli già presenti',
  catalogue_sync_counter_cars_created: 'Veicoli creati',
  catalogue_sync_counter_cars_not_created: 'Veicoli non creati',
  catalogue_sync_counter_links_deleted: 'Collegamenti rimossi',
  catalogue_sync_counter_links_inserted: 'Collegamenti inseriti',
  catalogue_sync_counter_info_written: 'Informazioni prodotto aggiornate',
  catalogue_sync_counter_status_cleared: 'Stati azzerati',
  catalogue_sync_counter_details_written: 'Dettagli aggiornati',
  catalogue_sync_counter_prices_written: 'Prezzi aggiornati',
  catalogue_sync_counter_prices_skipped: 'Prezzi saltati',
  catalogue_sync_counter_oems_written: 'OEM aggiornati',
  catalogue_sync_counter_categories_rejected: 'Categorie respinte',
  catalogue_sync_counter_values_truncated: 'Valori troncati',
  catalogue_sync_counter_classe_mismatches: 'Discordanze di classe',
  catalogue_sync_counter_car_label_blank: 'Etichetta veicolo mancante',
  catalogue_sync_counter_prices_not_numeric: 'Prezzi non numerici',
  catalogue_sync_counter_prices_code_only: 'Coppie codice/prezzo incomplete',
  catalogue_sync_counter_dates_unparseable: 'Date non interpretabili',
  catalogue_sync_counter_suppliers_not_listed: 'Fornitori non in elenco',
  catalogue_sync_counter_descrizione_conflicts: 'Descrizioni discordanti',
  catalogue_sync_counter_cod_oem_conflicts: 'OEM discordanti',
  catalogue_sync_counter_ultimo_aggiornamento_conflicts: 'Date aggiornamento discordanti',
  catalogue_sync_supplier_col_name: 'Fornitore',

  // ── Ordina catalogo esportazione (drag-to-reorder, block-local) ──────────
  catalogue_order_col_code: 'Codice',
  catalogue_order_col_description: 'Descrizione',
  catalogue_order_col_quality: 'Qualità',
  catalogue_order_col_category: 'Categoria',
  catalogue_order_col_status: 'Stato',
  catalogue_order_col_oem: 'OEM',
  catalogue_order_block_unpositioned: 'Non posizionato',
  catalogue_order_not_imported_banner:
    "Il catalogo non è ancora stato importato: l'ordine mostrato è l'ordine attuale del file di esportazione. Un riordino manuale resta valido solo fino alla prossima importazione del catalogo master.",
  catalogue_order_inconsistent_title: 'Ordine del catalogo incoerente',
  catalogue_order_inconsistent_banner:
    "L'ordine del catalogo risulta incoerente e va segnalato al supporto tecnico prima di continuare a riordinare. Veicoli coinvolti: {ids}",
  catalogue_order_inconsistent_recheck: 'Ricontrolla',
  catalogue_order_search_label:
    'Cerca per codice, descrizione, OEM o codice prodotto del fornitore',
  catalogue_order_search_button: 'Cerca',
  catalogue_order_search_next: 'Successivo',
  catalogue_order_search_too_short: 'Digita almeno 2 caratteri',
  catalogue_order_search_no_match: 'Nessun risultato trovato',
  catalogue_order_search_matches: '{count} risultati trovati',
  catalogue_order_search_matches_truncated:
    '{total} risultati trovati (mostrati i primi {returned})',
  catalogue_order_error_anchor_impossible:
    'La posizione richiesta non è più valida: qualcun altro ha modificato questo veicolo nel frattempo. Riprova a trascinare.',
  catalogue_order_error_row_not_in_catalogue:
    'Questo prodotto non fa più parte del catalogo di esportazione: la riga è stata aggiornata.',
  catalogue_order_row_not_found:
    'Il prodotto non è stato trovato: potrebbe essere uscito dal catalogo di esportazione. Aggiorna la pagina.',
}

export default carbody
